import { Suspense } from 'react';
import type { Feedback26CoStep } from '@/stores/feedback-26-co';
import type { FeedbackFormMentor, FeedbackSponsor } from '@/types';
import { Aura } from './steps/Aura';
import { EventQuality } from './steps/EventQuality';
import { Extras } from './steps/Extras';
import { Future } from './steps/Future';
import { Improvement } from './steps/Improvement';
import { OverallExperience } from './steps/OverallExperience';
import { Sponsors } from './steps/Sponsors';
import { ThankYou } from './steps/ThankYou';

interface StepRouterProps {
  step: Feedback26CoStep;
  mentor: FeedbackFormMentor | null;
  sponsors: FeedbackSponsor[];
  qualityLabels: Record<string, string>;
}

function StepLoading() {
  return (
    <div className="animate-pulse space-y-4">
      <div className="h-10 rounded bg-card" />
      <div className="h-64 rounded bg-card" />
    </div>
  );
}

export function StepRouter({
  step,
  mentor,
  sponsors,
  qualityLabels,
}: StepRouterProps) {
  return (
    <Suspense fallback={<StepLoading />}>
      {step === 'overall' && <OverallExperience mentor={mentor} />}
      {step === 'quality' && <EventQuality qualityLabels={qualityLabels} />}
      {step === 'improvement' && <Improvement />}
      {step === 'sponsors' && <Sponsors sponsors={sponsors} />}
      {step === 'future' && <Future />}
      {step === 'extras' && <Extras />}
      {step === 'aura' && <Aura />}
      {step === 'thank-you' && <ThankYou />}
    </Suspense>
  );
}
